import type { FaireProductEntity } from "../../entity_types/product";

export const p_9ynfknybd6: FaireProductEntity = {
  token: "p_9ynfknybd6",
  type: "product",
  name: "Floral Half Zip Kangaroo Pocket Drawstring Hoodie",
  brandToken: "b_b5qvtl6s4w",
  brandName: "PRETTY BASH",
  imageUrl:
    "https://cdn.faire.com/fastly/dd00ff8567f1b22975a3ac7a4a278aa417ba930d5e913f20e6c947e11a9799b0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/21a8514bb2a213cae2617e0bcd5f832865c30985d60873e761150d86cbc14719.jpeg",
    "https://cdn.faire.com/fastly/6a60b04f093281602a79595fbe76945e0fd43599552805faea160ab7e47ef180.jpeg",
    "https://cdn.faire.com/fastly/6c0164c102158857d9c1dac62d9a0ee4e70250a997763f02ccc0d071cd069cd4.jpeg",
    "https://cdn.faire.com/fastly/2f10600e064235d885f8b0be70b186551eb5db6838b7de21c1d715416184824b.jpeg",
    "https://cdn.faire.com/fastly/d8b18faf3dd66995df1d555cd18826c8db1f651b283b262264d3595fcd2fce47.png",
    "https://cdn.faire.com/fastly/56a688f7917d3f263641334f6d1b563b37f61cd1ea953ae836bb648441e5655f.png",
    "https://cdn.faire.com/fastly/d73a905db6330017b805d9beedf72286a8f08a7f24481f16ac5a4a096b9e1b22.png",
  ],
  priceDollars: 22.32,
  description:
    "Stay cozy and stylish in our hoodie. Featuring a vibrant floral print and a convenient half zip design, this hoodie is perfect for layering up on breezy days. The roomy kangaroo pouch keeps your hands warm and your essentials close, while adjustable drawstrings let you find your perfect fit. Ready for any casual adventure, it brings fun and comfort together in one charming package. 100% Polyester\n\n\nSize Info: \nSee size chart for approximate measurements\n\nSeason: Fall, Autumn, Winter, Spring\n",
  tags: [],
  msrpDollars: 44.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:21.816Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
